import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appPreventEnterSubmit]'
})
export class PreventEnterSubmitDirective {

  @HostListener('keydown.enter', ['$event'])
  onEnter(event: KeyboardEvent) {
   const keyboardEvent = event as KeyboardEvent;
   const target = event.target as HTMLElement;
   if(keyboardEvent.key === 'Enter' && (target.tagName.toLowerCase() !== 'textarea')) {
    keyboardEvent.preventDefault();
   } 
  }
}